/**
 * Keyboard driving: WASD + arrows, Space = handbrake, Shift / N = nitro.
 * Listeners on window (capture) so keys work even when canvas isn't focused.
 */
const GAME_CODES = new Set([
  'Space',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'KeyW',
  'KeyA',
  'KeyS',
  'KeyD',
  'KeyN',
]);

function isGameKey(code: string): boolean {
  return GAME_CODES.has(code);
}

export class KeyboardDriveInput {
  private keys = new Set<string>();
  dispose: () => void;

  constructor() {
    const down = (e: Event) => {
      const ke = e as KeyboardEvent;
      if (ke.metaKey || ke.ctrlKey) return;
      if (ke.code === 'ShiftLeft') {
        this.keys.add(ke.code);
        return;
      }
      if (isGameKey(ke.code)) {
        ke.preventDefault();
      }
      this.keys.add(ke.code);
    };
    const up = (e: Event) => {
      const ke = e as KeyboardEvent;
      this.keys.delete(ke.code);
    };
    const opts = { capture: true } as const;
    window.addEventListener('keydown', down, opts);
    window.addEventListener('keyup', up, opts);
    this.dispose = () => {
      window.removeEventListener('keydown', down, opts);
      window.removeEventListener('keyup', up, opts);
    };
  }

  getThrottle(): number {
    let t = 0;
    if (this.keys.has('KeyW') || this.keys.has('ArrowUp')) t += 1;
    if (this.keys.has('KeyS') || this.keys.has('ArrowDown')) t -= 1;
    return Math.max(-1, Math.min(1, t));
  }

  getSteer(): number {
    let s = 0;
    if (this.keys.has('KeyA') || this.keys.has('ArrowLeft')) s -= 1;
    if (this.keys.has('KeyD') || this.keys.has('ArrowRight')) s += 1;
    return Math.max(-1, Math.min(1, s));
  }

  getHandbrake(): boolean {
    return this.keys.has('Space');
  }

  getNitro(): boolean {
    return this.keys.has('ShiftLeft') || this.keys.has('KeyN');
  }
}
